var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopIconalert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66668 7.5C1.66668 3.35787 5.02455 0 9.16668 0C13.3088 0 16.6667 3.35787 16.6667 7.5V10.6729L18.2737 14.6905C18.3765 14.9473 18.3452 15.2382 18.19 15.4672C18.035 15.6962 17.7765 15.8333 17.5 15.8333H0.833333C0.556817 15.8333 0.2983 15.6962 0.143283 15.4672C-0.0117499 15.2382 -0.0430832 14.9472 0.0596001 14.6905L1.66668 10.6729V7.5Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 17.5C6.30553 18.9412 7.60747 20 9.16675 20C10.726 20 12.028 18.9412 12.396 17.5H5.9375Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopIconalert);
export default __webpack_public_path__ + "static/media/top_iconalert.4698b8346df3d3c79eeb63b547095822.svg";
export { ForwardRef as ReactComponent };